import { ApiTypes } from './api/types/api-types'
import { API } from 'project/api'

type APISingleton<T extends ApiTypes = ApiTypes> = {
  instance: T | undefined
}

const api: APISingleton = {
  instance: undefined,
}

// @ts-ignore
const getApi: () => ApiTypes = () => {
  if (!API) {
    throw new Error(
      'API is not initialized. Make sure Web or Mobile sets api.instance',
    )
  }
  return API
}

const setApi = <T extends ApiTypes>(apiParam: T) => {
  api.instance = apiParam
}

export { getApi, setApi }
